<template>
    <div class="membership-search app-search">
        <div class="input text">
            <label for="user-search" v-if="label">{{ label }}</label>
            <input id="user-search" v-model="query" :placeholder="placeholder">
        </div>
        <ul class="membership-search__results app-search__results">
            <li class="app-search__results-none" v-if="status">{{ status }}</li>
            <li v-for="user in limitedResults" :key="`user-${user.id}`">
                <button
                    type="button"
                    class="app-search__results-option"
                    @click="select(user)">
                    {{ user.name }}
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'

export default {
    props: {
        url: {
            type: String,
            default: '/admin/users'
        },
        placeholder: {
            type: String,
            default: 'Search Members'
        },
        label: {
            type: String,
            default: 'Add Member'
        },
        ignore: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            status: null,
            query: '',
            resultsLimit: 10,
            results: []
        }
    },
    watch: {
        query: _.debounce(function () { this.search() }, 250)
    },
    computed: {
        limitedResults () {
            const filtered = _.filter(this.results, ({ id }) => {
                return this.ignore.indexOf(id) === -1
            })
            return _.take(filtered, this.resultsLimit)
        }
    },
    methods: {
        async search () {
            if (!this.query.length) {
                this.results = []
                this.status = null
                return
            }

            this.status = 'Searching...'
            const params = { query: this.query }
            try {
                const response = await axios.get(this.url, { params })
                this.results = _.get(response, 'data.data.results', [])
                this.status = !this.limitedResults.length ? 'No results.' : null
            } catch (err) {
                console.error(err)
                this.status = 'Error fetching data.'
            }
        },
        select (user) {
            this.$emit('selected', user)
            this.results.splice(this.results.indexOf(user))
            this.query = ''
        }
    }
}
</script>
